// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"categoryDropdown_wrapper__45LFg","link":"categoryDropdown_link__o443D","text":"categoryDropdown_text__5nZ5G"};